import { Component } from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';
import { FormGroup, FormLabel } from 'react-bootstrap';

import { getOutlets } from '../../../actions/outlet';
import OutletSubmissions from './outlet-submissions';

class SubmissionsDashboard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedOutlet: null,
      selectedOutletId: null,
      shouldDisplayTable: false
    };
  }

  UNSAFE_componentWillMount() {
    const { dispatch } = this.props;

    dispatch(getOutlets(false));
  }

  handleOnChange = (option) => {
    if (!option) {
      this.setState({
        selectedOutletId: null,
        selectedOutlet: null,
        shouldDisplayTable: false,
      });
      return;
    }
    this.setState({
      selectedOutletId: option.value,
      selectedOutlet: this.props.outlets.find(outlet => outlet.id === option.value),
      shouldDisplayTable: true,
    });
  }

  render() {
    const { outlets, handleTabSelect } = this.props;
    const { selectedOutlet, selectedOutletId, shouldDisplayTable } = this.state;

    const outletsData = outlets.map(outlet => (
      {
        value: outlet.id,
        label: outlet.attributes.name
      }
    ));
    const selectedOption = outletsData.find(o => o.value === selectedOutletId) || null;

    return (
      <div>
        <FormGroup
          className="select-formgroup form-group dashboard-select"
        >
          <FormLabel>Outlet</FormLabel>
          <Select
            className='form-control'
            classNamePrefix="rs"
            isClearable
            isSearchable
            closeMenuOnSelect
            onChange={option => this.handleOnChange(option)}
            options={outletsData}
            placeholder={'Choose an Outlet'}
            value={selectedOption}
          />
        </FormGroup>
        {shouldDisplayTable && (
          <h4>{selectedOutlet.attributes.name}</h4>
        )}
        <div>
          {shouldDisplayTable && (
            <div>
              <OutletSubmissions
                key={selectedOutlet.id}
                outlet={selectedOutlet}
                handleTabSelect={handleTabSelect}
              />
            </div>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  outlets: state.stores.stores || []
});

export default connect(mapStateToProps)(SubmissionsDashboard);
